// extracted by mini-css-extract-plugin
export default {"list":"Texture_list__aOQEY","name":"Texture_name__LZjN2","checkbox":"Texture_checkbox__-Mfea","checked":"Texture_checked__SnsD9"};